import { RelatedDocumentItem } from '@layouts/Related/Related.types';
import React from 'react';

interface ThumbnailProps {
  item: RelatedDocumentItem;
}

export const Thumbnail = ({ item }: ThumbnailProps) => {
  let iconClass = 'icon-file-empty';
  if (item && item.FileCategory && item.FileCategory === 'bimobject') {
    iconClass = 'icon-link-ext';
  } else if (item && item.MimeType) {
    const mimeType = item.MimeType.toLowerCase();
    switch (true) {
      case mimeType === 'pdf':
        iconClass = 'icon-pdf';
        break;
      case mimeType === 'xlsx' || mimeType === 'xls':
        iconClass = 'icon-file-excel';
        break;
      case mimeType === 'docx' || mimeType === 'doc':
        iconClass = 'icon-file-word';
        break;
      case mimeType === 'pptx' || mimeType === 'ppt':
        iconClass = 'icon-file-ppt';
        break;
      case mimeType === 'zip' || mimeType === 'tar' || mimeType === '7z':
        iconClass = 'icon-file-archive';
        break;
      default:
        iconClass = 'icon-file-empty';
    }
  }

  return (
    <div className='c-document-list-item-thumbnail'>
      <i
        className={`c-document-list-item-thumbnail svg-icon pr-8 ${iconClass} icon-related-document`}
      />
    </div>
  );
};
